// eslint-disable-next-line import/prefer-default-export
export const MODE_TYPES = {
    PART: 'part',
    ALL: 'all',
};
